import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '../utils/cn'

interface InfoBoxProps {
  title?: string
  children: React.ReactNode
  className?: string
}

export function InfoBox({ title, children, className }: InfoBoxProps) {
  const { t } = useTranslation()
  const heading = title ?? t('common.note')
  return (
    <div className={cn('info-box', className)}>
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-medium text-blue-600 mb-1">{heading}</p>
          <div className="info-box-text">{children}</div>
        </div>
      </div>
    </div>
  )
}
